import styled from "styled-components";
import { TableCell } from "@mui/material";
import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";

export const Container = styled(KOGTableRow)`
	&&& {
		.MuiIconButton-root.Mui-disabled {
			color: rgba(0, 0, 0, 0.34);
		}
	}
`;

export const EllipsisCell = styled(TableCell)`
	&&& {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;
